import { AnelRota } from './anel-rota';

export class Anel {
    anelID: number; 
    nome: string;
    rotas: AnelRota[];
}